import { useSession } from "hooks/useSession";
import React from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";

export default function DeleteModal({ id, title, message, apiUrl, onSuccess, deleteid, deleteKey }) {
  const { userid } = useSession();

  const handleDelete = async () => {
    const formData = new FormData();
    formData.append("id", typeof deleteid === 'object' ? deleteid?.id : deleteid);
    formData.append("userid", userid);
    formData.append("action", "DELETE");
    if (deleteKey) {
      formData.append(deleteKey, typeof deleteid === 'object' ? deleteid?.id : deleteid);
    }

    try {
      const response = await fetchWrapper(apiUrl, {
        method: "POST",
        body: formData,
      });
      const result = response;

      if (result.status) {
        showMainToast(result.data || "Deleted successfully!", "success");
        if (onSuccess) onSuccess();

        const modalEl = document.getElementById(id);
        if (modalEl) {
          const modal = window.bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();
        }
      } else {
        showMainToast(result.data || "Failed to delete", "danger");
      }
    } catch (error) {
      console.error(error);
      showMainToast("Server error, please try again later", "danger");
    }
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "500px" }}>
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "24px", overflow: "hidden", backgroundColor: "#ffffff" }}
        >
          {/* Top Soft Pink Header Banner */}
          <div
            className="p-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)",
              borderBottom: "1px solid #f9a8d4"
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    color: "#ec4899",
                    boxShadow: "0 4px 12px rgba(236, 72, 153, 0.15)"
                  }}
                >
                  <i className="ph-duotone ph-trash" style={{ fontSize: "24px" }}></i>
                </div>
                <h4 className="fw-bold mb-0" style={{ color: "#1e1b4b", fontSize: "20px" }}>
                  {title || "Delete Role"}
                </h4>
              </div>

              <button
                type="button"
                className="btn p-0 d-flex align-items-center justify-content-center border-0 bg-transparent text-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ width: "32px", height: "32px", cursor: "pointer" }}
              >
                <i className="ph-bold ph-x" style={{ fontSize: "18px", color: "#64748b" }}></i>
              </button>
            </div>
          </div>

          {/* Modal Body */}
          <div className="p-4 text-center">
            {/* Center Graphic Illustration */}
            <div className="d-flex justify-content-center mb-3">
              <div
                className="position-relative d-flex align-items-center justify-content-center"
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  backgroundColor: "#ffe4e6"
                }}
              >
                <i className="ph-duotone ph-trash" style={{ fontSize: "44px", color: "#ec4899" }}></i>
                <div
                  className="position-absolute d-flex align-items-center justify-content-center"
                  style={{
                    bottom: "2px",
                    right: "2px",
                    width: "28px",
                    height: "28px",
                    borderRadius: "50%",
                    backgroundColor: "#ffffff"
                  }}
                >
                  <i className="ph-fill ph-warning-octagon" style={{ fontSize: "24px", color: "#ef4444" }}></i>
                </div>
              </div>
            </div>

            {/* Main Question & Description */}
            <h5 className="fw-bold mb-2" style={{ color: "#0f172a", fontSize: "19px" }}>
              {message || "Are you sure you want to delete this role?"}
            </h5>
            <p
              className="text-muted mx-auto mb-0"
              style={{ fontSize: "13.5px", maxWidth: "380px", lineHeight: "1.5" }}
            >
              This action cannot be undone. All data associated with this role will be permanently removed.
            </p>
          </div>

          {/* Modal Footer */}
          <div className="p-4 pt-0 border-0 d-flex align-items-center justify-content-center gap-3">
            <button
              type="button"
              className="btn px-4 d-inline-flex align-items-center justify-content-center"
              data-bs-dismiss="modal"
              style={{
                height: "46px",
                minWidth: "140px",
                borderRadius: "30px",
                backgroundColor: "#f1f5f9",
                border: "1px solid #e2e8f0",
                color: "#475569",
                fontWeight: "600",
                fontSize: "14.5px"
              }}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn px-4 d-inline-flex align-items-center justify-content-center gap-2 text-white shadow-sm"
              onClick={handleDelete}
              style={{
                height: "46px",
                minWidth: "150px",
                borderRadius: "30px",
                background: "linear-gradient(135deg, #ec4899 0%, #d946ef 100%)",
                border: "none",
                fontWeight: "600",
                fontSize: "14.5px",
                boxShadow: "0 4px 14px rgba(236, 72, 153, 0.35)"
              }}
            >
              <i className="ph-bold ph-trash" style={{ fontSize: "16px" }}></i>
              <span>Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

